import App from '@app/app';

export class FlightRecorderService {
  constructor() {
    this._records = [];
  }

  log(message) {
    this._records.push({
      t: new Date().toISOString(),
      m: message
    });
  }

  records() {
    return JSON.stringify(this._records);
  }

  clear() {
    this._records = [];
  }
}

App.service('FlightRecorderService', FlightRecorderService);
